const DispatchPlanning = {

    // FIELDS
    "dispatch_date": "تاريخ الإرسال",
    "driver": "السائق",
    "vehicle": "المركبة",
    "route": "المسار",
    "dispatch_advice": "نصيحة الإرسال",
    "date": "التاريخ",
    "delivery_date": "تاريخ التسليم",
    "dispatch_advice_id": "معرف نصيحة الإرسال",
    "customer": "العميل",
    "action": "الإجراء",
    "search": "بحث",

    // PAGE HEADER
    "dispatch_planning": "تخطيط الإرسال",

    // ERROR
    "error_dispatch_date": "اختر التاريخ",
    "error_driver": "اختر السائق",
    "error_vehicle": "اختر المركبة",
    "error_route": "اختر المسار",
    "error_dispatch_advice": "لم يتم العثور على نصيحة الإرسال",

    // TABLE HEADER
    "table_planning_id": "معرّف التخطيط",
    "table_date": "تاريخ",
    "table_driver": "السائق",
    "table_driver_contact": "اتصال السائق",
    "table_vehicle": "المركبة",
    "table_regitration_number": "رقم التسجيل",
    "table_route": "المسار",
}

export default DispatchPlanning;